import { authService } from "../../../services";
import FanEventPage from "./FanEventPage";
import PublicFanEventPage from "./PublicFanEventPage";

function FanEventPageWrapper() {
  if (authService.isAuthenticated()) {
    return <FanEventPage />;
  } else {
    return <PublicFanEventPage />;
  }
}

export default FanEventPageWrapper;
